class SalesforceAbandonedCartUtils {
	static clientEmail = ''
	static catalogId = ''
	static subscriberKey = ''
	static cartOrOrderData = []
	/**
	 * Defines if should log messages in the console.
	 */
	static debug = false
	/**
	 * Should be called as soon as possible.
	 */
	static setOrganizationId(salesforceOrganizationId: string) {
		_etmc.push(['setOrgId', salesforceOrganizationId])
		if (this.debug) {
			console.log(`Successfully set the organization id: ${salesforceOrganizationId}`)
		}
	}

	/**
	 * Should be called as soon as possible.
	 */
	static setCatalogId(catalogId: string) {
		this.catalogId = catalogId
		if (this.debug) {
			if (this.catalogId) {
				console.log(`Successfully set the catalog id: ${this.catalogId}`)
			} else {
				console.log('Couldn\'t set catalog id because it is not valid.')
			}
		}
	}

	/**
	 * Should be called after the client enters his email in:
	 * - The email subscription lightbox
	 * - The email subscription in the footer
	 * - The email subscription in the checkout page
	 */
	static setClientEmail(email: string) {
		this.clientEmail = email?.trim()
		if (this.clientEmail) {
			console.log(`Successfully set the client email: ${this.clientEmail}`)
			SalesforceAbandonedCartUtils.setSubscriberKey()
		} else if (this.debug) {
			console.log('Couldn\'t set client email because it is not valid.')
		}

	}

	/**
	 * Should be called after `setCatalogId` and `setClientEmail`.
	 */
	private static setSubscriberKey() {

		if (this.clientEmail && this.catalogId) {
			this.subscriberKey = `${this.catalogId.toLowerCase()}_${this.clientEmail}`
			if (this.debug) {
				console.log(`Successfully set subscriber key: ${this.subscriberKey}`)
			}
		} else if (this.debug) {
			console.log('Couldn\'t set subscriber key because client email or catalog id is not valid.')
		}
	}

	/**
	 * Should be called for each new product added to the cart (after clicking "Add to cart").
	 */
	static addCartOrOrderData({ item, quantity, price, salePrice: salePrice, uniqueId: uniqueId }: {
		item: any
		quantity: any
		price: any
		salePrice?: any
		uniqueId: any
	}) {
		const product = {
			item: item,
			quantity: quantity,
			price: price,
			sale_price: salePrice ?? undefined,
			unique_id: uniqueId
		}

		const cartItem = this.cartOrOrderData.find((el) => el.unique_id === uniqueId)

		if(cartItem) {
			cartItem.quantity = (Number(cartItem.quantity) + Number(quantity)).toString()
		} else {
			this.cartOrOrderData.push(product)
		}

		if (this.debug) {
			console.log('Sucessfully added to the cart:\n', product)
		}
	}

	/**
	 * Sends the cart data to Salesforce.
	 */
	static trackCart() {
		if (this.subscriberKey) {
			_etmc.push(['setUserInfo', { email: this.subscriberKey }])
			if (this.cartOrOrderData.length > 0 && this.cartOrOrderData.length < 11) {
				_etmc.push(['trackCart', { cart: this.cartOrOrderData }])
			} else {
				_etmc.push(['trackCart', { clear_cart: true }])
			}

			if (this.debug) {
				console.log(`Successfully tracked the cart for ${this.subscriberKey} with:\n`, this.cartOrOrderData)
			}
		} else {
			if (this.debug) {
				console.log(`Couldn't track cart because subscriber key is not valid: ${this.subscriberKey}.`)
			}
		}
	}

	/**
	 * Should be called if the order is completed by the client.
	 */
	static trackConversion() {
		if (this.subscriberKey) {
			_etmc.push(['setUserInfo', { email: this.subscriberKey }])
			_etmc.push(['trackPageView'])
			_etmc.push(['trackConversion', { cart: this.cartOrOrderData }])
			_etmc.push(['trackCart', { 'clear_cart': true }])

			if (this.debug) {
				console.log(`Successfully tracked the conversion for ${this.subscriberKey} with:\n`, this.cartOrOrderData)
			}
		} else {
			if (this.debug) {
				console.log(`Couldn't track conversion because subscriber key is not valid: ${this.subscriberKey}.`)
			}
		}
	}
}